import {
  type ConfigOf,
  Element,
  InstallSpec,
  ItemComponent,
} from "@p0security/shared/install/types";

export const SalesforceComponents = InstallSpec({
  "iam-write": ItemComponent({
    type: "string",
    label: "Access management",
    description: "Use P0 to provision users with groups and permission sets",
    maturity: "preview",
    schema: {
      fullDomain: Element({
        type: "string",
        label: "Full Salesforce domain",
        description:
          "Your full Salesforce domain, including domain suffix (e.g. my-org-domain.foo.my.salesforce.com); defaults to {domain}.my.salesforce.com",
        optional: true,
      }),
      consumerKey: Element({
        type: "string",
        label: "Consumer key",
        description: "External client application's consumer key",
      }),
      consumerSecret: Element({
        type: "encrypted",
        label: "Consumer secret",
        description: "External client application's consumer secret",
      }),
    },
  }),
});

export type SalesforceComponents = typeof SalesforceComponents;

export type SalesforceIntegration = ConfigOf<SalesforceComponents>;
